import 'slick-carousel'
import jQuery from 'jquery'
import imagesLoaded from 'imagesloaded'

class Slider {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = elem
        this._options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: true,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null,
            rows: 0,
            arrowKeys: false
        }, JSON.parse(this.elem.dataset.slider ? this.elem.dataset.slider : '{}'))
        this._preloads = this.elem.querySelectorAll('[data-preload]')
        this._slideCount = this.elem.querySelector('[data-slide-count]')

        if (this._options.mobileOnly) {
            this._options.showBelow = 769
        }

        this._pauseAutoplayElems = this.elem.querySelectorAll('[data-pause-autoplay]')

        if (!this._options.dontInit) {
            this.preloadItems()
        }
    }

    onInit () {
    }

    goToSlide (x, dontAnimate = false) {
        jQuery(this.elem).slick('slickGoTo', parseInt(x), dontAnimate)
    }

    goToNextSlide (x) {
        jQuery(this.elem).slick('slickNext')
    }

    goToPrevSlide (x) {
        jQuery(this.elem).slick('slickPrev')
    }

    focus () {
        this.elem.focus()
    }

    vertialHeightFix ($slider) {
        let maxHeight = -1
        let slides = $slider.$slider.get(0).querySelectorAll('.slick-slide')
        for (let slide of slides) {
            if (slide.clientHeight > maxHeight) {
                maxHeight = slide.clientHeight
            }
        }
        for (let slide of slides) {
            if (slide.clientHeight < maxHeight) {
                slide.style.margin = `${Math.ceil((maxHeight - slide.clientHeight) / 2)}px 0`
            }
        }
    }

    doEvents () {
        this.elem.addEventListener('changeSlide', e => {
            this.goToSlide(e.detail)
        })
        imagesLoaded(this.elem, () => {
            jQuery(this.elem).slick('setPosition')
        })
    }

    preloadItems () {
        let completedPreloads = 0
        if (this._preloads.length) {
            for (let elem of this._preloads) {
                elem.addEventListener('preload-complete', e => {
                    completedPreloads++
                    if (completedPreloads === this._preloads.length) {
                        this.init()
                    }
                })
            }
        } else {
            this.init()
        }
    }

    init () {
        if (this._options.showAbove && window.innerWidth <= this._options.showAbove) {
            return false
        }

        if (this._options.showBelow && window.innerWidth >= this._options.showBelow) {
            return false
        }

        if (this._options.arrowKeys) {
            this.elem.addEventListener('keydown', e => {
                console.log(e.key)
                if (e.key === 'ArrowLeft') {
                    this.goToPrevSlide()
                }
                if (e.key === 'ArrowRight') {
                    this.goToNextSlide()
                }
            })
        }

        jQuery(this.elem).on('init', (e, slick) => {
            this.elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid && this._options.playVideos) {
                vid.play()
                vid.removeAttribute('poster')
            }

            if (this._slideCount) {
                this._slideCount.innerHTML = `${(slick.currentSlide + 1) < 10 ? '0' : ''}${slick.currentSlide + 1}/${slick.slideCount < 10 ? '0' : ''}${slick.slideCount}`
            }

            if (this._options.vertical && this._options.adaptiveHeight) {
                this.vertialHeightFix(slick)
            }
        })

        jQuery(this.elem).on('setPosition', (e, slick) => {
            if (this._options.vertical && this._options.adaptiveHeight) {
                this.vertialHeightFix(slick)
            }
        })

        jQuery(this.elem).not('.slick-initialized').slick(this._options)

        jQuery(this.elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            if (!slick.$slides[curSlide]) return false
            let vid = slick.$slides[curSlide].querySelector('video')
            if (vid) {
                vid.pause()
            }
            if (this._slideCount) {
                this._slideCount.innerHTML = `${(nextSlide + 1) < 10 ? '0' : ''}${nextSlide + 1}/${slick.slideCount < 10 ? '0' : ''}${slick.slideCount}`
            }
        })

        jQuery(this.elem).on('afterChange', (e, slick, curSlide) => {
            if (!slick.$slides[curSlide]) return false
            let vid = slick.$slides[curSlide].querySelector('video')
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        if (this._options.autoplay) {
            for (let pauseElem of this._pauseAutoplayElems) {
                pauseElem.addEventListener('mouseenter', e => {
                    jQuery(this.elem).slick('slickPause')
                })
                pauseElem.addEventListener('mouseleave', e => {
                    jQuery(this.elem).slick('slickPlay')
                })
            }
        }

        this.doEvents()
    }
}

export default Slider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slider.js